<script context="module">
	import { z } from "zod";
	export const name = "Card";
	export const CustomFields = z.object({
		show_summary: z.boolean().optional(),
		summary_lines: z.number().min(1).max(4).optional(),
	});
</script>

<script>
	import { getContext } from "svelte";
	import ImageView from "@reperio-news/core.components/ImageView.svelte";
	import Kicker from "./Kicker.svelte";
	import Stamp from "./Stamp.svelte";

	export let data = {};
	export let id = undefined;
	export let type = undefined;
	export let indexInContainer = undefined;
	id || type || indexInContainer;

	const c = getContext("parentBlockColumnCount");

	$: content = data && data.content;
	$: cf = (data && data.custom_fields) || {};
	$: showSummary = cf.show_summary !== false;
	$: lines = cf.summary_lines || 3;
	// single-column context (bento cell, listing): request a larger image
	$: wide = !$c || $c === 1;
</script>

{#if content}
	<article class="af-card af-item af-item--card">
		{#if content.poster}
			<div class="af-card__media af-dim">
				<ImageView
					src={content.poster}
					crop={content.poster.crop}
					alt={content.title}
					width={wide ? 900 : 600}
					height={wide ? 600 : 400}
					widths={wide ? [900, 600, 450] : [600, 450, 300]}
					heights={wide ? [600, 400, 300] : [400, 300, 200]}
					fit="cover"
					loading="lazy"
				/>
			</div>
		{/if}
		<div class="af-card__body">
			<Kicker {content} />
			<h3 class="af-card__title"><a href={content.url}>{content.title}</a></h3>
			{#if showSummary && content.summary}
				<p class="af-card__summary" style="--af-lines: {lines}">{content.summary}</p>
			{/if}
			<Stamp {content} />
		</div>
	</article>
{/if}

<style lang="scss">
	@use "../../styles/mixins" as m;

	.af-card {
		@include m.af-card;
	}

	.af-card__media {
		aspect-ratio: 3 / 2;
		overflow: hidden;
		background: var(--af-surface-sunk);

		:global(picture),
		:global(img) {
			width: 100%;
			height: 100%;
			object-fit: cover;
		}
	}

	.af-card__body {
		display: flex;
		flex-direction: column;
		gap: var(--af-space-2);
		padding: var(--af-space-4);
		flex: 1 1 auto;
	}

	.af-card__title {
		font: 600 var(--af-text-h3) / var(--af-leading-tight) var(--af-font-serif);
		color: var(--af-ink);
		text-wrap: balance;

		a {
			@include m.af-stretched-link;
			@include m.af-clamp(3);
		}
	}

	.af-card__summary {
		font-size: var(--af-text-body-sm);
		line-height: 1.5;
		color: var(--af-ink-muted);
		@include m.af-clamp(var(--af-lines, 3));
	}

	.af-card :global(.af-item__stamp) {
		margin-top: auto;
		padding-top: var(--af-space-2);
	}

	@media (min-width: 768px) {
		.af-card__body {
			padding: var(--af-space-6);
		}
	}
</style>
